module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.carousel.pageCount > 1),
      expression: "carousel.pageCount > 1"
    }],
    staticClass: "VueCarousel-pagination",
    class: ( _obj = {}, _obj[("VueCarousel-pagination--" + _vm.paginationPositionModifierName)] = _vm.paginationPositionModifierName, _obj )
  }, [_c('div', {
    staticClass: "VueCarousel-dot-container",
    style: (_vm.dotContainerStyle),
    attrs: {
      "role": "tablist"
    }
  }, _vm._l((_vm.paginationCount), function(page, index) {
    return _c('button', {
      key: (page + "_" + index),
      staticClass: "VueCarousel-dot",
      class: {
        'VueCarousel-dot--active': _vm.isCurrentDot(index)
      },
      style: (_vm.dotStyle(index)),
      attrs: {
        "aria-hidden": "false",
        "role": "tab",
        "title": _vm.getDotTitle(index),
        "value": _vm.getDotTitle(index),
        "aria-label": _vm.getDotTitle(index),
        "aria-selected": _vm.isCurrentDot(index) ? 'true' : 'false'
      },
      on: {
        "click": function($event) {
          _vm.goToPage(index)
        }
      }
    })
  }))])
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3719ecff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/packages/vue-carousel/Pagination.vue
// module id = 1989
// module chunks = 2